export const getPowerlistDialerProductMap = (
  POWERDIALER_MACHINE_DETECT_PRODUCT_ID
) => {
  return [
    {
      id: 0,
      displayName: 'None',
      product: '',
    },
    {
      id: 30,
      displayName: 'PowerDialer One',
      product: 'powerlistDialer1',
    },
    {
      id: 31,
      displayName: 'PowerDialer Four',
      product: 'powerlistDialer4',
    },
    {
      id: 32,
      displayName: 'PowerDialer Ten',
      product: 'powerlistDialer10',
    },
    {
      id: POWERDIALER_MACHINE_DETECT_PRODUCT_ID ?? 44,
      displayName: 'PowerDialer AI Human Detect',
      product: 'powerlistDialerMachineDetect',
    },
  ];
};
export const products = [
  { productId: 17, product: 'basicphone', agentSeat: 1, tier: 'Basic' },
  {
    productId: 19,
    product: 'integratedphone',
    agentSeat: 1,
    tier: 'Integrated',
  },
  {
    productId: 21,
    product: 'enterprisephone',
    agentSeat: 1,
    tier: 'Enterprise',
  },
  {
    productId: 23,
    product: 'basicphoneunlimited',
    agentSeat: 1,
    tier: 'Basic Unlimited',
  },
  {
    productId: 24,
    product: 'integratedphoneunlimited',
    agentSeat: 1,
    tier: 'Integrated Unlimited',
  },
  {
    productId: 25,
    product: 'enterprisephoneunlimited',
    agentSeat: 1,
    tier: 'Enterprise Unlimited',
  },
  { productId: 26, product: 'localpresencelite', agentSeat: 0, tier: null },
  { productId: 27, product: 'ftcblocking', agentSeat: 0, tier: null },
  { productId: 29, product: 'calltranscription', agentSeat: 0, tier: null },
  { productId: 30, product: 'powerlistDialer1', agentSeat: 0, tier: null },
  { productId: 31, product: 'powerlistDialer4', agentSeat: 0, tier: null },
  { productId: 32, product: 'powerlistDialer10', agentSeat: 0, tier: null },
  {
    productId: 44,
    product: 'powerlistDialerMachineDetect',
    agentSeat: 0,
    tier: null,
  },
  { productId: 45, product: 'payperuse', agentSeat: 0, tier: 'payperuse' },
];

export const getBillingTiers = (Role, role) => ({
  'Enterprise Unlimited': {
    tier: 1,
    unlimited: 1,
    hide: true,
  },
  Enterprise: {
    tier: 1,
    unlimited: 0,
  },
  'Integrated Unlimited': {
    tier: 2,
    unlimited: 1,
    hide: true,
  },
  Integrated: {
    tier: 2,
    unlimited: 0,
  },
  'Basic Unlimited': {
    tier: 3,
    unlimited: 1,
    hide: true,
  },
  Basic: {
    tier: 3,
    unlimited: 0,
    hide: role !== Role.SUPERADMIN,
  },
  payperuse: {
    tier: 4,
    unlimited: 0,
    hide: role !== Role.SUPERADMIN,
  },
});
